import React, { FunctionComponent } from 'react';

import Alert from '@justgiving/alert';
import config from '../../config';
import { useChrome } from '../../hooks/useChrome';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useTranslation } from 'react-i18next';

export const NotAuthorised: FunctionComponent = () => {
  useChrome();
  const { t } = useTranslation();
  useDocumentTitle(t('home.heading'));

  return (
    <Alert
      type="error"
      displayType="inline"
      className="jg-space-mbsm jg-text--left"
    >
      <p>{t('error.onlyAvailableToUsBbgf')}</p>
      <p>
        <a
          href={config.base_url}
          className="sidebar-link"
          rel="noopener noreferrer"
        >
          {t('common.returnToCharityAdminHome')}
        </a>
      </p>
    </Alert>
  );
};
